/**
 * Integration Dashboard Component
 * Main dashboard for managing all integrations
 */

import React, { useState } from 'react';
import ProfessionalLoader from '../common/ProfessionalLoader';
import GoogleSheetsBackupDashboard from '../googleSheets/GoogleSheetsBackupDashboard';
import MailChimpIntegrationDashboard from '../mailchimp/MailChimpIntegrationDashboard';
import XeroIntegrationDashboard from '../xero/XeroIntegrationDashboard';
import './IntegrationDashboard.css';

const IntegrationDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isLoading] = useState(false);

  // Tab configuration
  const tabs = [
    { id: 'overview', label: 'Overview', icon: '📊' },
    { id: 'mailchimp', label: 'MailChimp', icon: '📧' },
    { id: 'google-sheets', label: 'Google Sheets', icon: '📊' },
    { id: 'xero', label: 'Xero', icon: '💰' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <div className="integration-overview">
            <h3>Integration Overview</h3>
            <p>Manage all your integrations from this central dashboard.</p>
            <div className="integration-cards">
              <div className="integration-card">
                <div className="integration-icon">📧</div>
                <h4>MailChimp</h4>
                <p>Email automation and list management</p>
                <button 
                  className="btn btn-primary"
                  onClick={() => setActiveTab('mailchimp')}
                >
                  Manage
                </button>
              </div>
              <div className="integration-card">
                <div className="integration-icon">📊</div>
                <h4>Google Sheets</h4>
                <p>Data backup and synchronization</p>
                <button 
                  className="btn btn-primary"
                  onClick={() => setActiveTab('google-sheets')}
                >
                  Manage
                </button>
              </div>
              <div className="integration-card">
                <div className="integration-icon">💰</div>
                <h4>Xero</h4>
                <p>Accounting and invoicing</p>
                <button 
                  className="btn btn-primary"
                  onClick={() => setActiveTab('xero')}
                >
                  Manage
                </button>
              </div>
            </div>
          </div>
        );
      case 'mailchimp':
        return (
          <div className="integration-details">
            <MailChimpIntegrationDashboard />
          </div>
        );
      case 'google-sheets':
        return (
          <div className="integration-details">
            <GoogleSheetsBackupDashboard />
          </div>
        );
      case 'xero':
        return (
          <div className="integration-details">
            <XeroIntegrationDashboard />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="integration-dashboard">
      <div className="integration-dashboard-header">
        <h2>Integration Dashboard</h2>
        <p>Manage all your third-party integrations</p>
      </div>

      <div className="integration-dashboard-content">
        <div className="integration-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`integration-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="integration-content">
          {isLoading ? (
            <div className="loading-container">
              <ProfessionalLoader message="Loading integrations..." size="large" variant="default" />
            </div>
          ) : (
            renderContent()
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegrationDashboard;
